(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-heading"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-filter-option')) {
    customElements.define(
      'accordion-filter-option',
      class AccordionFilterOption extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-accordion-filter]');
          this.input?.addEventListener('change', () => this.applyFilter());
        }

        applyFilter() {
          const scope = this.closest('.shopify-section') || document;
          const search = scope.querySelector('accordion-search');
          const update = () => (search?.search ? search.search() : window.AccordionFilter?.apply(scope));

          if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            document.startViewTransition(update);
          } else {
            update();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    if (!window.AccordionFilter) {
    window.AccordionFilter = {
      apply(scope) {
        const selected = Array.from(scope.querySelectorAll('[data-accordion-filter]:checked')).map((input) => input.value);
        const searchInput = scope.querySelector('[data-accordion-search]');
        const term = (searchInput?.value || '').trim().toLowerCase();
        const targets = Array.from(scope.querySelectorAll('.block-accordion[data-filter-key]')).filter(
          (accordion) => !accordion.querySelector('[data-accordion-filter], [data-accordion-search]')
        );
        let matches = 0;

        targets.forEach((accordion) => {
          const inCategory = selected.length === 0 || selected.includes(accordion.dataset.filterKey);
          let visibleRows = 0;

          accordion.querySelectorAll('.accordion').forEach((row) => {
            const show = inCategory && (!term || row.textContent.toLowerCase().includes(term));
            row.hidden = !show;
            if (show) visibleRows++;
          });

          accordion.hidden = !inCategory || (term !== '' && visibleRows === 0);
          matches += visibleRows;
        });

        return { term, matches };
      },
    };
  }

  if (!customElements.get('accordion-search')) {
    customElements.define(
      'accordion-search',
      class AccordionSearch extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-accordion-search]');
          this.message = this.querySelector('.accordion-search__empty');
          this.delay = Number(this.dataset.debounce) || 300;
          this.onInput = this.debounce(() => this.search(), this.delay);
          this.input?.addEventListener('input', this.onInput);
        }

        disconnectedCallback() {
          this.input?.removeEventListener('input', this.onInput);
          clearTimeout(this.timer);
        }

        debounce(fn, wait) {
          return (...args) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => fn.apply(this, args), wait);
          };
        }

        search() {
          const scope = this.closest('.shopify-section') || document;
          const { term, matches } = window.AccordionFilter.apply(scope);
          const value = this.input.value.trim();

          this.message.textContent =
            term !== '' && matches === 0 ? this.message.dataset.message.replace('__terms__', value) : '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
